import { IntegrationSettingsEntry, IntegrationSettingsUserLevelForm } from 'modules/integrationSettings/types';
import { IntegrationSettingsTable } from './IntegrationSettingsTable';
import { Box } from '@mui/material';

interface UserTabProps {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsUserLevelForm[];
}

export const UserTab = ({ integrationSettings, tableData }: UserTabProps) => {
  return (
    <Box mt={2}>
      <IntegrationSettingsTable integrationSettings={integrationSettings} tableData={tableData} />
    </Box>
  );
};
